import produce from 'immer';
import { Reducer } from 'redux';

import {
  IActivitiesActionTypes,
  IActivitiesState,
  IActivitiesTypes,
} from './types';

export const INITIAL_STATE: IActivitiesState = {
  loadingStartEvent: false,

  startEvent: undefined,
};

const Activities: Reducer<IActivitiesState, IActivitiesActionTypes> = (
  state = INITIAL_STATE,
  action: IActivitiesActionTypes,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IActivitiesTypes.GET_START_EVENT_REQUEST: {
        draft.loadingStartEvent = true;
        draft.startEvent = undefined;
        break;
      }
      case IActivitiesTypes.GET_START_EVENT_SUCCESS: {
        draft.loadingStartEvent = false;
        draft.startEvent = action.payload.startEvent;
        break;
      }
      case IActivitiesTypes.GET_START_EVENT_FAILURE: {
        draft.loadingStartEvent = false;
        break;
      }
      default:
    }
  });
};

export default Activities;
